export const STRIPE_MULTIPLIER = 100;

export const PAYMENT_METHOD_NEW_CARD = 'new-card';
